import { toString } from 'cronstrue';
import { TFunction } from 'i18next';

import { formatDateTime } from '~utils/dateUtils';
import { defaultPlaceholder } from '~utils/stringUtils';

export function unwrapCronExpression(input: string): string {
	const trimmed = input.trim();
	const match = /^cron\((.*)\)$/i.exec(trimmed);
	return (match?.[1] ?? trimmed).trim();
}

export function formatDateTimeCronExpression(dateTime: Date | undefined, t: TFunction): string {
	if (!dateTime) return defaultPlaceholder;
	const formatted = formatDateTime(dateTime);
	return formatted && formatted !== '-' ?
			t('at', { ns: 'date', date: formatted })
		:	defaultPlaceholder;
}

export function formatCronExpression(
	rawExpression: string | null | undefined,
	locale: string
): string {
	const effectiveLocale = (locale ?? 'en').split('-')[0];
	if (!rawExpression) return defaultPlaceholder;
	const cron = unwrapCronExpression(rawExpression);
	if (!cron) return defaultPlaceholder;
	try {
		return toString(cron, { locale: effectiveLocale, dayOfWeekStartIndexZero: false });
	} catch {
		try {
			// Fallback when locale is not supported by cronstrue.
			return toString(cron);
		} catch {
			return cron;
		}
	}
}
